<!-- <p>toc-settings works!</p> -->
<div>
    <div class="topic-style">{{ topic.name }}</div>
    <ul class="list-settings">
        <li class="list-spacing cursor-pointer" (click)="selectOrgLabel()">
            <div class="d-flex">
                <div>
                    <div [ngClass]="{ 'org-label-icon': !topic.isOrganisationalLabel, 'org-label-icon-active': topic.isOrganisationalLabel }"></div>
                </div>
                <div class="label" [ngClass]="{ 'highlighted-text': topic.isOrganisationalLabel }" title="Choosing this will avoid this topic to be part of any search">
                    Set as Organisational Label
                </div>
            </div>
        </li>
        <li class="list-spacing cursor-pointer" (click)="setArticleCount()">
            <div class="d-flex">
                <div>
                    <div [ngClass]="{ 'article-count-icon': !topic.isArticleCountToZero, 'article-count-icon-active': topic.isArticleCountToZero }"></div>
                </div>
                <div class="label" [ngClass]="{ 'highlighted-text': topic.isArticleCountToZero }" title="Choose this to restrict searching articles for this topic">
                    Set Article Count to Zero
                </div>
            </div>
        </li>
        <!-- Add a condition to hide it for root node -->
        <li class="list-spacing cursor-pointer" *ngIf="topic.level != 0" [ngClass]="{ disabled: topic.isArticleCountToZero || topic.isOrganisationalLabel }">
            <div class="d-flex" (click)="parentContextExpandCollapse()">
                <div>
                    <div [ngClass]="{ 'parent-context-icon': !enableParentContext, 'parent-context-icon-active': enableParentContext }"></div>
                </div>
                <div class="d-flex">
                    <div class="label" [ngClass]="{ 'highlighted-text': enableParentContext }" title="Select Parent topics which should be part of search">Set Parent Context</div>
                    <div style="padding-left: 5px; padding-top: 3px">
                        <fa-icon [icon]="faAngleDown" [ngClass]="{ 'highlighted-text': enableParentContext }"></fa-icon>
                    </div>
                </div>
            </div>
            <div *ngIf="enableParentContext" style="min-height: 10px; max-height: 110px; overflow-y: scroll; overflow-x: hidden">
                <div *ngFor="let upper of upperLevelNames" class="parent-context-check d-flex">
                    <div>
                        <input type="checkbox" [checked]="upper.checked" style="width: 15px; height: 15px" (change)="ParentContextSelect(upper.id, $event)" />
                    </div>
                    <div title="{{ upper.name }}" style="padding-left: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 150px">{{ upper.name }}</div>
                </div>
            </div>
        </li>
        <li class="list-spacing cursor-pointer" (click)="setGlobalRelevance()">
            <div class="d-flex">
                <div>
                    <div [ngClass]="{ 'global-relevance-icon': !topic.globalRelevance, 'global-relevance-icon-active': topic.globalRelevance }"></div>
                </div>
                <div
                    class="label"
                    [ngClass]="{ 'highlighted-text': topic.globalRelevance }"
                    title="Choosing this will move articles between topic hierarchy based on Relevance algorithm"
                >
                    Global Relevance
                </div>
            </div>
        </li>
        <li class="list-spacing cursor-pointer" (click)="setProcessNonArticles()">
            <div class="d-flex">
                <div>
                    <div [ngClass]="{ 'non-articles-icon': !topic.processNonArticles, 'non-articles-icon-active': topic.processNonArticles }"></div>
                </div>
                <div
                    class="label"
                    [ngClass]="{ 'highlighted-text': topic.processNonArticles }"
                    title="Choose this to process ads, dashboards and home pages of the searched articles"
                >
                    Process Non-Articles
                </div>
            </div>
        </li>
        <li class="list-spacing cursor-pointer" (click)="setskipRelevance()">
            <div class="d-flex">
                <div>
                    <div [ngClass]="{ 'skip-relevance-icon': !topic.skipRelevance, 'skip-relevance-icon-active': topic.skipRelevance }"></div>
                </div>
                <div class="label" [ngClass]="{ 'highlighted-text': topic.skipRelevance }" title="Choose this to make all searched articles as relevant">Skip Relevance</div>
            </div>
        </li>
    </ul>
</div>
<div>
    <button class="btn-custom btn-primary mr-3 mt-4 cursor-pointer col-sm-2 float-end" style="width: 70px" (click)="saveSettings()">Save</button>
</div>
